
import AccountDrawer from '@marketplace/components/AccountDrawer.vue'
import LocalePickerModal from '@marketplace/components/modals/ds/LocalePickerModal.vue'
import { DROPSHIPPING_SUBMENU_LINKS } from '@marketplace/components/nav/config/header-menu-links.js'
import CurrentLanguageMenuItem from '@marketplace/components/nav/parts/current-language-menu-item.vue'
import HeaderCoreSearch from '@marketplace/components/nav/parts/header-core-search.vue'
import PulseTooltipWrapper from '@marketplace/components/pulse/pulse-tooltip-wrapper.vue'
import OcDrawer from '@marketplace/components/shared/drawer/oc-drawer.vue'
import ocDrawerMixin from '@marketplace/components/shared/drawer/ocDrawerMixin.js'
import OrderchampLogo from '@marketplace/components/shared/icons/OrderchampLogo.vue'
import { trackHeaderClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderMarketplace',

    components: {
        AccountDrawer,
        CurrentLanguageMenuItem,
        OrderchampLogo,
        HeaderCoreSearch,
        OcDrawer,
        PulseTooltipWrapper,
    },

    mixins: [ocDrawerMixin],

    data() {
        return {
            showDropdownMenu: false,
            dropdownMenuTimeout: null,
            userType: window.Store.accountType,
        }
    },
    computed: {
        ...mapGetters('global', [
            'inboxUnreadCount',
            'userCountry',
            'isRetailer',
        ]),
        ...mapGetters('ocplus', ['canSeeOcPlus']),
        ...mapGetters('feature', ['hasOneBrandFeature']),
        ...mapGetters('ds', ['dsStorefronts']),

        links() {
            if (this.$helpers.isSupplierAccount) {
                return [
                    {
                        title: this.$t('nav.ds.section.explore'),
                        items: [
                            {
                                label: this.$t('nav.ds.find_brands'),
                                to: this.localePath({ name: 'ds-marketplace' }),
                                icon: 'far fa-store',
                            },
                        ],
                    },
                ]
            }

            const sideMenu = []

            const hasStorefronts =
                Array.isArray(this.dsStorefronts) &&
                this.dsStorefronts.length > 0
            const canShowExploreSection =
                !this.hasOneBrandFeature || hasStorefronts

            if (canShowExploreSection) {
                const items = this.hasOneBrandFeature
                    ? this.dsStorefronts.map((sf) => ({
                          label: sf.storefront?.name,
                          to: this.localePath({
                              name: 'ds-store-slug',
                              params: { slug: sf.storefront?.slug },
                          }),
                          icon: 'far fa-store',
                      }))
                    : [
                          {
                              label: this.$t('nav.ds.find_brands'),
                              to: this.localePath({ name: 'ds-marketplace' }),
                              icon: 'far fa-store',
                          },
                      ]

                sideMenu.push({
                    title: this.$t('nav.ds.section.explore'),
                    items,
                })
            }

            sideMenu.push(
                {
                    title: this.$t('nav.ds.section.orders'),
                    items: [
                        {
                            label: this.$t('nav.ds.orders'),
                            to: this.localePath({ name: 'ds-orders' }),
                            icon: 'far fa-archive',
                        },
                    ],
                },
                {
                    title: this.$t('nav.ds.section.catalog'),
                    items: [
                        {
                            label: this.$t('nav.ds.import_list'),
                            to: this.localePath({ name: 'ds-import-list' }),
                            icon: 'far fa-download',
                            hasTooltip: true,
                        },
                        {
                            label: this.$t('nav.ds.connected_brands'),
                            to: this.localePath({ name: 'ds-brands' }),
                            icon: 'far fa-store-alt',
                        },
                        {
                            label: this.$t('nav.ds.product_updates'),
                            to: this.localePath({ name: 'ds-product-updates' }),
                            icon: 'far fa-sync-alt',
                            id: 'ds_product_updates',
                            notificationCount:
                                this.unreadDropshippingNotificationsCount,
                        },
                    ],
                },
                {
                    title: this.$t('nav.ds.section.other'),
                    items: [
                        {
                            label: this.$t('nav.ds.inbox'),
                            to: this.localePath({ name: 'ds-inbox' }),
                            icon: 'far fa-envelope',
                            notificationCount: this.inboxUnreadCount,
                        },
                        {
                            label: this.$t('nav.ds.subscription'),
                            to: this.localePath({ name: 'ds-subscription' }),
                            icon: 'far fa-credit-card',
                        },
                        {
                            label: this.$t('nav.ds.settings'),
                            to: this.localePath({ name: 'ds-settings' }),
                            icon: 'far fa-cog',
                        },
                    ],
                }
            )

            return sideMenu
        },

        accountLinks() {
            if (this.isRetailer) {
                return DROPSHIPPING_SUBMENU_LINKS
            }

            return DROPSHIPPING_SUBMENU_LINKS.filter(
                (link) => link?.routeName !== 'ds-settings-account'
            )
        },
    },

    mounted() {
        this.$store.commit(
            'global/updateHeaderHeight',
            this.$refs.header.clientHeight
        )
    },

    methods: {
        trackHeaderClick,
        triggerHamburgerMenu() {
            this.__openDrawer('hamburger-dropshipping')
        },
        openAccountDrawer() {
            this.__openDrawer('account')
        },
        triggerLanguageCurrencyModal() {
            this.$vfm.show({
                component: LocalePickerModal,
            })
        },
        triggerHowItWorksModal() {
            EventBus.$emit('modal-open', 'modal-how-OC-works', {
                closeButtonText: this.$t('labels.skip'),
            })
        },
        openDropdownMenu() {
            this.showDropdownMenu = true
            clearTimeout(this.dropdownMenuTimeout)
        },
        closeDropdownMenu() {
            this.dropdownMenuTimeout = setTimeout(() => {
                this.showDropdownMenu = false
            }, 150)
        },
        canBeShown(hiddenFor) {
            if (!hiddenFor) return true
            if (hiddenFor.includes('notAssociationMember'))
                return this.isAssociationRetailer === false
            if (hiddenFor.includes('isOCPlus')) return this.canSeeOcPlus
            if (!hiddenFor.includes(this.userType)) return true
            return false
        },
        handleDynamicComponentClick(methodToCall) {
            if (!methodToCall) return
            this[methodToCall]()
        },
    },
}
